import { createRouter, createWebHistory } from 'vue-router'
import { authGuard, superAdminGuard } from '@/router/guards'
import SchoolListView from '@/views/SchoolListView.vue'
import SchoolCreateView from '@/views/SchoolCreateView.vue'
import SchoolCopyView from '@/views/SchoolCopyView.vue'
import SchoolDetailView from '@/views/SchoolDetailView.vue'

const router = createRouter({
  // History mode (not hash) so Keycloak's Authorization Code fragment
  // (?code=&state=) doesn't collide with the router's own #/ hash — that
  // collision swallowed the auth code and left the app unauthenticated.
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/schools',
    },
    {
      path: '/schools',
      name: 'schools',
      component: SchoolListView,
      beforeEnter: [authGuard, superAdminGuard],
    },
    {
      path: '/schools/create',
      name: 'schools-create',
      component: SchoolCreateView,
      beforeEnter: [authGuard, superAdminGuard],
    },
    {
      path: '/schools/:id',
      name: 'schools-detail',
      component: SchoolDetailView,
      props: true,
      beforeEnter: [authGuard, superAdminGuard],
    },
    {
      path: '/schools/:id/copy',
      name: 'schools-copy',
      component: SchoolCopyView,
      props: true,
      beforeEnter: [authGuard, superAdminGuard],
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/schools',
    },
  ],
})

export default router
